import { validateReviewForEventCreation } from "./draftToEvent";
import type { InvoiceImportCandidate } from "./types";

export type ImportReviewState = {
  markedReady: boolean;
  canMarkReady: boolean;
  canCreateEvent: boolean;
  /** Shown when Create Event is disabled */
  createBlockingReasons: string[];
  /** Shown when Mark Ready is disabled */
  markReadyBlockingReasons: string[];
  unresolvedReviewCount: number;
};

type Options = {
  readOnly?: boolean;
  isCreating?: boolean;
  isMarkingReady?: boolean;
};

export function getImportReviewState(
  item: InvoiceImportCandidate | undefined,
  options: Options = {},
): ImportReviewState {
  const readOnly = options.readOnly ?? Boolean(item?.importedEventId);
  const markedReady = Boolean(item?.markedReady);
  const draft = item?.draft;

  const fieldErrors = draft ? validateReviewForEventCreation(draft) : ["Invoice review data is not loaded."];
  const unresolvedReviewCount = draft?.lines.filter((line) => line.needsReview).length ?? 0;

  const markReadyBlockingReasons = readOnly
    ? []
    : markedReady
      ? []
      : [...fieldErrors];

  const createBlockingReasons: string[] = [];
  if (readOnly) {
    createBlockingReasons.push("This invoice has already been imported.");
  } else {
    if (!markedReady) {
      createBlockingReasons.push("Mark this invoice ready before creating the Event.");
    }
    createBlockingReasons.push(...fieldErrors);
  }

  const canMarkReady =
    !readOnly && !markedReady && !options.isMarkingReady && markReadyBlockingReasons.length === 0;

  const canCreateEvent =
    !readOnly &&
    markedReady &&
    !options.isCreating &&
    fieldErrors.length === 0;

  return {
    markedReady,
    canMarkReady,
    canCreateEvent,
    createBlockingReasons,
    markReadyBlockingReasons,
    unresolvedReviewCount,
  };
}
